module.exports = __webpack_public_path__ + "static/media/swimming.b84070ee.svg";